if (document.querySelector("body#pageTop") !== null) {
  document.addEventListener("DOMContentLoaded", () => {



    let sW = window.innerWidth;



    {
      const sec = document.querySelector('#jsSecMain');
      const wrap = sec.querySelector('.js-main-wrap');
      const imgBox = wrap.querySelector('.js-img-box');
      const copyBox = wrap.querySelector('.js-copy-box');

      setTimeout(() => {
        imgBox.classList.add('is-act')
      }, 1000);
      setTimeout(() => {
        copyBox.classList.add('is-act')
      }, 2000);
    }



    {
      const secs = document.querySelectorAll('.js-sec-ful');

      secs.forEach((element, index) => {

        const wrap = element.querySelector('.js-ful-wrap');
        const area = element.querySelector('.js-img-area');
        const coverBox = element.querySelector('.js-cover-box');
        const ttlBox = element.querySelector('.js-ttl-box');
        const copyBox = element.querySelector('.js-copy-box');

        gsap.to(area, {
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: area,
            start: '0% 0%',
            endTrigger: wrap,
            end: '100% 100%',
            pin: true,
            // markers: true,
          }
        });

        gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: wrap,
            start: "50% 100%",
            onEnter: () => coverBox.classList.add('is-act'),
            // onLeave: () => console.log("onLeave"),
            // onEnterBack: () => console.log("onEnterBack"),
            onLeaveBack: () => coverBox.classList.remove('is-act'),
            // markers: true,
          },
        })

        gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: ttlBox,
            start: "0% 80%",
            onEnter: () => ttlBox.classList.add('is-act'),
            // onLeave: () => console.log("onLeave"),
            // onEnterBack: () => console.log("onEnterBack"),
            onLeaveBack: () => ttlBox.classList.remove('is-act'),
            // markers: true,
          },
        })

        gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: copyBox,
            start: "0% 80%",
            onEnter: () => copyBox.classList.add('is-act'),
            // onLeave: () => console.log("onLeave"),
            // onEnterBack: () => console.log("onEnterBack"),
            onLeaveBack: () => copyBox.classList.remove('is-act'),
            // markers: true,
          },
        })

      });
    }



    {
      const sec = document.querySelector('#jsSecLists');

      const listWrap = sec.querySelector('.js-list-wrap');
      const accordion = listWrap.querySelector('.js-accordion-outer');

      const btnWrap = sec.querySelector('.js-btn-wrap');
      const btnBox = btnWrap.querySelector('.js-btn-box');

      btnBox.addEventListener('click', () => {
        if (btnBox.classList.contains('is-act') == true) {
          accordion.classList.remove('is-act');
          btnBox.classList.remove('is-act');
        } else {
          accordion.classList.add('is-act');
          btnBox.classList.add('is-act');
        }
      });
    }



  });
}